export function unserializeString(data: string) {
  if (!data.startsWith('s:')) return null;

  const arr = /^s:\d+:"(.*)";$/.exec(data);
  return arr?.[1];
}
